import type { MetadataValidationResponse } from '@src/models/dtos/metadata';
import AnchorLink from '@src/components/atoms/links/anchor-link';
import { invalidMetadataInfo } from '@src/utils/governanceActionUtils';
import TriangleErrorIcon from '@src/components/icons/triangleErrorIcon';

export default function MetadataErrorCard({
  metadataResponse,
}: {
  metadataResponse: MetadataValidationResponse | null;
}) {
  const reasonComponent = () => {
    if (metadataResponse?.reason) {
      if (typeof metadataResponse?.reason === 'string') {
        return (
          <p className="body14 flex flex-col gap-2 font-semibold sm:flex-row">
            Reason:
            <span className="break-all font-normal text-semantic-error-500">
              {metadataResponse.reason}
            </span>
          </p>
        );
      }
      return (
        <div className="body14 flex flex-col gap-2 font-bold">
          <p className="flex flex-col gap-2 sm:flex-row">
            Actual Hash:
            <span className="break-all font-normal text-semantic-error-500">
              {metadataResponse.reason.currentHash}
            </span>
          </p>
          <p className="flex flex-col gap-2 sm:flex-row">
            Expected Hash:
            <span className="break-all font-normal text-semantic-success-500">
              {metadataResponse.reason.expectedHash}
            </span>
          </p>
        </div>
      );
    }
  };

  if (metadataResponse && !metadataResponse.valid && metadataResponse.status)
    return (
      <div className="flex w-full gap-4 rounded-xl border border-semantic-error-500 bg-dark-neutral-600 p-4">
        <div className="h-[38px] w-[38px] rounded-full bg-semantic-error-100 p-[10px] shadow-Error-Shadow-1">
          <TriangleErrorIcon className="h-[18px] w-[18px] text-semantic-error-500" />
        </div>
        <div className="flex flex-col gap-[8px]">
          <p className="h24 font-bold text-semantic-error-500">
            {invalidMetadataInfo(metadataResponse.status).title}
          </p>
          <p className="body14 mb-1 mt-2 font-medium text-semantic-error-200">
            {invalidMetadataInfo(metadataResponse.status).subtitle}
          </p>
          <p className="body14 font-semibold text-semantic-error-200">
            {invalidMetadataInfo(metadataResponse.status).description}
          </p>
          {reasonComponent()}
          <AnchorLink
            className="body14 mt-4 w-fit rounded-xl bg-dark-neutral-900 px-3 py-2 font-medium dark:text-white"
            target="_blank"
            href="https://docs.gov.tools/cardano-govtool/using-govtool/dreps/drep-error-conditions"
          >
            Learn More
          </AnchorLink>
        </div>
      </div>
    );
  return null;
}
